// import axios from 'axios'
// state
const state = {
  calendarData: null,
  kpisDashboard: null,
  kpisLast: null,
  socialNetworks: null
}

// getters
const getters = {
  getCalendarData (state) {
    return state.calendarData
  },
  getCampainDetailData (state) {
    return state.campaignDetail
  },
  getCampainLevelState (state) {
    return state.campaignLevelState
  },
  getCampainLevelProcedure (state) {
    return state.campaignLevelProcedure
  },
  getSocialNetworksData (state) {
    return state.socialNetworks
  },
  getKpisIntervalData (state) {
    return state.kpisInterval
  },
  getKpisData (state) {
    return state.kpisDashboard
  },
  getKpisLastData (state) {
    return state.kpisLast
  }
}

// actions
const actions = {
  // Update data Calendar
  /* updateCalendar ({ commit, state }, data) {
    state.calendarData = null
    axios.get(`/api/dashboard/calendar/event?date=${data}`).then((response) => {
      commit('UPDATE_CALENDAR', response.data)
    }).catch((error) => {
      console.log('error', error)
    })
  }, */
  updateCalendar ({ commit, state }, data) {
    const store = this
    state.calendarData = null
    let dataService = {
      method: 'GET',
      endpoint: '/api/dashboard/calendar/event',
      data: null,
      params: {
        date: data,
        country: 'ES',
        region: 'ES-GC',
        city: 'ES LPA'
      },
      mutation: 'UPDATE_CALENDAR'
    }
    store.dispatch('callService', dataService)
  },
  // Update social Network
  updateSocialNetworks ({ commit, state }, data) {
    const store = this
    state.socialNetworks = null
    let dataService = {
      method: 'GET',
      endpoint: '/api/dashboard/social',
      data: null,
      params: {
        size: data.size,
        country: 'ES',
        region: 'ES-GC',
        city: 'ES LPA'
      },
      mutation: 'UPDATE_SOCIALNETWORKS'
    }
    store.dispatch('callService', dataService)
  },
  // Update data Kpis interval
  updateKpisInterval ({ commit, state }, data) {
    const store = this
    state.kpisInterval = null
    let dataService = {
      method: 'GET',
      endpoint: '/api/kpis/' + data.product + '/interval',
      data: null,
      params: {
        product: data.product,
        type: data.type,
        interval: data.interval,
        intervalUnit: data.intervalUnit,
        city: 'ES LPA'
      },
      mutation: 'UPDATE_KPIS_INTERVAL'
    }
    store.dispatch('callService', dataService)
  },
  // Update data Kpis Dashboard
  updateKpisDashboard ({ commit, state }, data) {
    const store = this
    state.kpisDashboard = null
    let dataService = {
      method: 'GET',
      endpoint: '/api/dashboard/kpi/' + data,
      data: null,
      params: {
        country: 'ES',
        region: 'ES-GC',
        city: 'ES LPA'
      },
      tipo: data,
      mutation: 'UPDATE_KPIS_DASHBOARD'
    }
    store.dispatch('callService', dataService)
  },
  // Update data Kpis Last
  updateKpisLast ({ commit, state }, data) {
    const store = this
    state.kpisLast = null
    let dataService = {
      method: 'GET',
      endpoint: '/api/kpis/' + data.product + '/last',
      data: null,
      params: {
        product: data.product,
        type: data.type,
        city: 'ES LPA'
      },
      mutation: 'UPDATE_KPIS_LAST'
    }
    store.dispatch('callService', dataService)
  }
}

// mutations
const mutations = {
  UPDATE_CALENDAR (state, data) {
    state.calendarData = data
  },
  UPDATE_SOCIALNETWORKS (state, data) {
    state.socialNetworks = data
  },
  UPDATE_KPIS_INTERVAL (state, data) {
    state.kpisInterval = data
  },
  UPDATE_KPIS_DASHBOARD (state, data) {
    if (data.tipo) {
      let tipo = data.tipo
      delete data.tipo
      for (var i = 0; i < Object.keys(data).length; i++) {
        data[Object.keys(data)[i]].type = tipo
      }
    }
    state.kpisDashboard = data
  },
  UPDATE_KPIS_LAST (state, data) {
    state.kpisLast = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard.js